<template>
	<div id="cooperation">
		<div class="container">


			<div class="companyInfoIpt">
				<!-- <div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						校企合作需求发布
					</div>
				</div> -->
				<!-- <img src="../img/jobShadowing2.png" alt="" style="width: 700px;height: 150px;margin-bottom: 30px;cursor: pointer;" @click="openPDF"/> -->
				<div class="bg"  @click="openPDF">
					<div class="title">
						校企合作需求发布
					</div>
					<div class="subheading">
						<div class="">
							活动介绍
						</div>
						<img src="../img/more3.png" alt="" />
					</div>
				</div>	
				<div class="iptContainer">
					<div class="" style="display: flex;align-items: baseline;margin-bottom: 30px;">
						<div class="" style="font-weight: bold;font-size: 16px;color: #000000;margin-right: 10px;">
							校企对接需求
						</div>
						<div class="" style="font-weight: 500;font-size: 14px;color: #807F7F;">
							发布后推送至700+合作高校
						</div>
					</div>
					
					<div class="" v-for="(item,index) in university_enterprise" :key="index">
					
					<div class="ipt" style="margin-bottom: 0;" :style="index>0?'border-top: 1px solid rgb(229, 229, 229);padding-top: 30px;':''">
						<!-- <div class="text">
							<span>直播操作：</span>
						</div> -->
						<!-- <el-button type="primary" style="background: #0084FF;" v-if="item.xet_alive_code"
							@click="liveStreaming(item.xet_alive_code)">点击开启直播</el-button> -->
					</div>	
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text" style="width:700px;display: flex;justify-content: space-between;">
							<div class="">
								<span style="color:#FF4A4A">*</span>项目类型{{university_enterprise.length>1?index+1:''}}（单选）
							</div>
							<!-- <el-button type="danger" :disabled="university_enterprise.length==1&&!item.projectType"  @click="deleteItem(index)">删除</el-button> -->
							<div class="" style="display: flex;align-items: center;cursor: pointer;"  v-if="university_enterprise.length!=1" @click="deleteItem(index)">
								<div class="" style="color:#606266;font-size: 14px;margin-right: 5px;">
									删除
								</div>
								<img src="../img/del.png" alt="" style="width: 15px;height: 15px;" />
							</div>
						</div>
						<div class="singleChoice">
							<div class="item" @click="select(index,'实习基地')">
								<div class="left">
									<img src="../img/selected1.png" alt="" v-if="item.projectType=='实习基地'" />
									<img src="../img/select1.png" alt="" v-else />
								</div>
								<div class="right">
									实习基地
								</div>
							</div>
							
							<div class="item" @click="select(index,'订单班/课程共建')">
								<div class="left">
									<img src="../img/selected1.png" alt="" v-if="item.projectType=='订单班/课程共建'" />
									<img src="../img/select1.png" alt="" v-else />
								</div>
								<div class="right">
									订单班/课程共建
								</div>
							</div>
							
							<div class="item" @click="select(index,'科研项目')">
								<div class="left">
									<img src="../img/selected1.png" alt="" v-if="item.projectType=='科研项目'" />
									<img src="../img/select1.png" alt="" v-else />
								</div>
								<div class="right">
									科研项目
								</div>
							</div>
							
							<div class="item" @click="select(index,'受聘为企业导师')">
								<div class="left">
									<img src="../img/selected1.png" alt="" v-if="item.projectType=='受聘为企业导师'" />
									<img src="../img/select1.png" alt="" v-else />
								</div>
								<div class="right">
									受聘为企业导师
								</div>
							</div>
							
							<div class="item" @click="select(index,'其他')" style="border: none;">
								<div class="left">
									<img src="../img/selected1.png" alt="" v-if="item.projectType=='其他'" />
									<img src="../img/select1.png" alt="" v-else />
								</div>
								<div class="right">
									其他
								</div>
							</div>

						</div>
					</div>
					
					
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>需求描述
						</div>
						<el-input type="textarea" autosize :disabled='!item.projectType'
							placeholder="请输入需求描述"
							v-model="item.description" maxlength="200" show-word-limit>
						</el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>拟合作学校/院校层次
						</div>
						<el-input type="textarea" autosize :disabled='!item.projectType'
							placeholder="请输入拟合作学校/院校层次"
							v-model="item.schoolLevel" maxlength="100" show-word-limit>
						</el-input>
					</div>
					
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>拟合作专业
						</div>
						<el-input type="textarea" autosize :disabled='!item.projectType'
							placeholder="请输入拟合作专业"
							v-model="item.major" maxlength="100" show-word-limit>
						</el-input>
					</div>
					
					</div>
					
					<div class="" style="padding: 0 0 20px 0;display: flex;align-items: center;justify-content: flex-end;width: 700px;border-bottom: 1px solid #E5E5E5;margin-bottom: 30px;">
						<div class="" style="font-size: 14px;color: #0084FF;cursor: pointer;" @click="addDemand">
							继续增加校企对接需求
						</div>
						<img src="../img/add.png" alt="" style="width: 15px;height: 15px;"/>
					</div>
					
					<div class="" style="display: flex;align-items: baseline;margin-bottom: 30px;">
						<div class="" style="font-weight: bold;font-size: 16px;color: #000000;margin-right: 10px;">
							平台合作需求
						</div>
						<div class="" style="font-weight: 500;font-size: 14px;color: #807F7F;">
							专人跟进服务
						</div>
					</div>
					
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							校招宣讲会进校服务 
						</div>
						<el-input type="textarea" autosize
							placeholder="请输入招宣讲会进校服务"
							v-model="campusPresentation" maxlength="200" show-word-limit>
						</el-input>
					</div>
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							校园RPO业务  
						</div>
						<el-input type="textarea" autosize
							placeholder="请输入校园RPO业务"
							v-model="campusRpo" maxlength="200" show-word-limit>
						</el-input>
					</div>
					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							其他校企合作项目  
						</div>
						<el-input type="textarea" autosize
							placeholder="请输入其他校企合作项目"
							v-model="other" maxlength="200" show-word-limit>
						</el-input>
					</div>
					
				</div>

				<div class="btnContainer">
					<el-button class="cancel" @click="cancel" v-if="isAmend">取消</el-button>
					<el-button type="primary" @click="submit">{{isAmend?'修改需求':'提交需求'}}</el-button>
				</div>
			</div>
		</div>

		<!-- <el-dialog :visible.sync="mapDialogVisible" title="选择地点" width="600px" :close-on-click-modal='false' :before-close="handleClose">
			<getMapLocation  @selectLocation='selectLocation' @close='close' :isjobShadowing='true'
				></getMapLocation>
		</el-dialog> -->

	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import getMapLocation from '../components/getMapLocation.vue'
	export default {
		data() {
			return {
				radio: '',
				selectIndex:-1,
				describe:'',
				
				university_enterprise:[{
					projectType:'',
					description:'',
					schoolLevel:'',
					major:''
				}],
				
				
				
				
				
				campusPresentation:'',
				campusRpo:'',
				other:'',
				
				isAmend:false
			};
		},
		components: {
			getMapLocation,
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		mounted() {
			this.getcreateExploring()
		},
		methods: {
			...mapMutations(['setIslogin']),
			cancel(){
				this.$confirm('是否取消该对接需求', '提示', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$util.post(
						"v2/user/creatDemandInfo", {
							admin_id:this.schoolInfo.admin_id,
							university_enterprise:JSON.stringify([]),
							platform:JSON.stringify({})
						},
					
						(res) => {
							if (res.code == 200) {
								this.$message({
									message: '取消成功',
									type: 'success'
								});
								setTimeout(() => {
									this.$router.push({
										path: "/personalCenter",
									});
								}, 1000)
								
							}
						}
					);
				}).catch(() => {
				
				});
			},
			openPDF(){
				window.open('https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/15/%E5%8D%83%E6%A0%A1%E4%B8%87%E4%BC%81%E6%B4%BB%E5%8A%A8%E4%BB%8B%E7%BB%8D.pdf','_blank')
			},
			getcreateExploring() {
				this.$util.post(
					"v2/user/getDemandList", {
						admin_id:this.schoolInfo.admin_id
					},
					(res) => {
						if (res.code == 200) {
							console.log(res)
							if(res.data.university_enterprise){
								let university_enterprise =  JSON.parse(res.data.university_enterprise)
								if(university_enterprise.length>0){
									this.university_enterprise = university_enterprise
									this.isAmend = true
								}
							}
							if(res.data.platform){
								let platform = JSON.parse(res.data.platform)
								this.campusPresentation=platform.campusPresentation,
								this.campusRpo=platform.campusRpo,
								this.other=platform.other
							}
						}
					})
			},
			deleteItem(index) {
				if (this.university_enterprise.length == 1) {
					this.university_enterprise.splice(index, 1)
					this.university_enterprise.push({
						projectType:'',
						description:'',
						schoolLevel:'',
						major:''
					})
				} else {
					this.university_enterprise.splice(index, 1)
				}
			},
			addDemand(){
				this.university_enterprise.push({
					projectType:'',
					description:'',
					schoolLevel:'',
					major:''
				})
			},
			submit() {
				console.log(this.university_enterprise)
				
				let university_enterprise = JSON.parse(JSON.stringify(this.university_enterprise))
				
				let isNull = ''
				for (let i = 0; i < university_enterprise.length; i++) {
				    // liveList[i].value1 = liveList[i].value1.trim()
				    university_enterprise[i].projectType = university_enterprise[i].projectType.trim()
				    university_enterprise[i].description= university_enterprise[i].description.trim()
				    university_enterprise[i].schoolLevel= university_enterprise[i].schoolLevel.trim()
				    university_enterprise[i].major= university_enterprise[i].major.trim()
				    
					if(!university_enterprise[i].major){
					    isNull = '请填写拟合作专业'
					}
					if(!university_enterprise[i].schoolLevel){
					    isNull = '请填写拟合作学校/院校层次'
					}
					if(!university_enterprise[i].description){
					    isNull = '请填写需求描述'
					}
					if(!university_enterprise[i].projectType){
					    isNull = '请选择项目类型'
					}
					// if (liveList[i].value1 ==''|| liveList[i].title == '' || liveList[i]
					// 	.event_person == '' || liveList[i].person_desc == '' || liveList[i].header_intr == '' ||
					// 	liveList[i].event_desc == '' || liveList[i].event_img == '') {
					// 	isNull = true
					// 	break
					// }
				}
				if (isNull) {
					this.$message({
						message: isNull,
						type: 'error'
					});
					return 
				}
				
				// if(this.campusPresentation.trim()==''){
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入招宣讲会进校服务'
				// 	});
				// 	return 
				// }
				
				// if(this.campusRpo.trim()==''){
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入校园RPO业务'
				// 	});
				// 	return 
				// }
				
				// if(this.other.trim()==''){
				// 	this.$message({
				// 		type: 'error',
				// 		message: '请输入其他校企合作项目'
				// 	});
				// 	return 
				// }
				let platform = {
					campusPresentation:this.campusPresentation,
					campusRpo:this.campusRpo,
					other:this.other
				}
				this.$util.post(
					"v2/user/creatDemandInfo", {
						admin_id:this.schoolInfo.admin_id,
						university_enterprise:JSON.stringify(this.university_enterprise),
						platform:JSON.stringify(platform)
					},
				
					(res) => {
						if (res.code == 200) {
							this.$message({
								message: '保存成功',
								type: 'success'
							});
							setTimeout(() => {
								let is_demo = sessionStorage.getItem('demo')
								if(is_demo){
									this.$router.push({
										path: '/meeting?demo='+is_demo,
									})
								}else{
									this.$router.push({
										path: '/meeting',
									})
								}
							}, 1000)
							
						}
					}
				);
				
			},
			select(index,text){
				this.university_enterprise[index].projectType = text
			}

		},

	};
</script>
<style>
	#cooperation .cancel{
		color: #AEAEAE !important;
		background: #ffffff !important;
		border-color: #d0d0d0 !important;
	}
	#cooperation .avatar-uploader1 .el-upload {
		border: none !important;
	}

	#cooperation .el-date-editor.el-input__inner {
		flex: 1 !important;
	}
	#cooperation .el-textarea__inner {
		min-height: 90px !important;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 0 0 0;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				// .avatarContainer {
				// 	display: flex;
				// 	// align-items: center;
				// 	align-items: flex-start;
				// 	margin-bottom: 30px;

				// 	.text {
				// 		width: 100px;
				// 		display: flex;
				// 		align-items: center;
				// 		font-weight: 500;
				// 		font-size: 18px;
				// 		color: #333333;
				// 		margin-right: 20px;
				// 	}

				// 	.upload {
				// 		margin-right: 20px;
				// 	}

				// 	.uploadContainer {
				// 		display: flex;
				// 		align-items: center;

				// 		.uploadText {
				// 			width: 310px;
				// 			font-weight: 500;
				// 			font-size: 16px;
				// 			color: #999999;
				// 		}
				// 	}

				// }

				.ipt {
					width: 700px;
					// display: flex;
					// align-items: center;
					margin-bottom: 20px;

					.text {
						// width: 135px;
						width: 150px;
						display: flex;
						align-items: center;
						margin-right: 10px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						margin-bottom: 15px;

						// justify-content: flex-end;
						span {
							font-weight: 500;
							font-size: 14px;
							color: #000;
						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
						
					}
				}

			}

			.btnContainer {
				width: 700px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;

				// .el-button--primary {
				// 	background-color: #0084FF !important;
				// 	border-color: #0084FF !important;
				// 	// border-radius: 10px !important;
				// }
			}
		}


	}

	.companyContainer {
		display: flex;
		align-items: flex-start;
		width: 700px;

		.text {
			width: 78px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-weight: 400;
			font-size: 14px;
			color: #000;
			margin-right: 10px;
		}

		.el-input {
			flex: 1 !important;
		}

		.company {
			flex: 1;
			background: #FFFFFF;
			border-radius: 5px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			padding: 15px 15px 20px 15px;

			.top {
				display: flex;
				align-items: center;
				width: 100%;
				border-bottom: 1px solid #dcdcdc69;
				margin-bottom: 20px;

				padding: 0 5px 15px 5px;

				.uplodadCompany1 {}

				.uplodadCompany {
					display: flex;
					align-items: center;
					font-size: 0;
					margin-left: 10px;

					img {
						width: 20px;
						height: 20px;
						margin-right: 12px;
					}

					.btn {
						font-weight: 500;
						font-size: 14px;
						color: #3A84E9;
					}
				}
			}

			.companyImg {
				display: flex;
				align-items: center;
				// padding: 0 15px;
				font-size: 0;

				img {
					width: 195px;
					height: 120px;
					margin-right: 15px;
				}

				div {
					font-weight: 500;
					font-size: 14px;
					color: #999;
					display: flex;
					// align-items: center;
					justify-content: space-between;
					flex-direction: column;
				}

			}
		}
	}

	.addNewContainer {
		width: 700px;
		display: flex;
		// align-items: flex-end;
		justify-content: flex-end;
		margin-bottom: 30px;

		.addNew {
			width: 600px;
			height: 60px;
			background: #f9fbff;
			border-radius: 5px;

			text-align: center;
			line-height: 60px;
			font-weight: 500;
			font-size: 14px;
			color: #3A84E9;
			cursor: pointer;
		}
	}
	.singleChoice {
		border-radius: 5px;
		border: 1px solid #DCDCDC;
		padding: 0px 10px;
		.item{
			display: flex;
			align-items: center;
			border-bottom: 1px solid #E5E5E5;
			padding: 10px;
			cursor: pointer;
			.left{
				font-size: 0;
				margin-right: 20px;
				img{
					width: 20px;
					height: 20px;
				}
			}
			.right{
				font-size: 14px;
				color: #424141;
			}
		}
		
	}
	
	.bg{
		width:700px;
		height: 120px;
		background-image: url(../img/bg6.png) ;
		background-repeat: no-repeat;
		cursor: pointer;
		margin-bottom: 30px;
		box-sizing: border-box;
		padding: 30px 25px;
		border-radius: 10px;
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		.title{
			color: #009AFF;
			font-size: 20px;
			font-weight: bold;
			// margin-bottom: 10px;
		}
		.subheading{
			font-size: 0;
			display: flex;
			align-items: center;
			div{
				color: #606266;
				font-size: 14px;
				margin-right: 5px;
			}
			img{
				width: 10px;
				height: 10px;
			}
		}
	}
</style>

<style>
	#register .el-input__inner {
		font-size: 16px;
	}

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}



	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
		cursor: pointer;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 500px;
	}


	
</style>